var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c("p", _vm._g({}, on), [
                    _vm._v(
                      _vm._s(_vm.calculateTime(_vm.params.node.data.timestamp))
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(new Date(_vm.params.node.data.timestamp).toLocaleString())
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }